import { createEvent, createStore, restore, sample } from 'effector'
import { message } from 'antd'

import { fx } from '../../../../../../libs'
import { ProductSubscription, UpdateSubscriptionsBody } from './types'

export const emailsTabMounted = createEvent<string>()

export const saveProduct = createEvent<{
  id: number
  body: UpdateSubscriptionsBody
}>()

export const getSubscriptions = fx<void, ProductSubscription[]>({
  method: 'GET',
})

export const updateSubscriptions = fx<UpdateSubscriptionsBody, unknown>({
  method: 'PUT',
})

// нужен, чтобы перезапросить список после успешного сохранения
export const $clientId = restore(emailsTabMounted, null)

export const $subscriptions = restore<ProductSubscription[]>(
  getSubscriptions.doneData.map((doneData) => doneData.body),
  [],
)

export const $loadError = createStore<string>('')
  .on(
    getSubscriptions.failData,
    (_, failData) =>
      failData.body.message || 'Couldn’t load subscriptions. Refresh the page.',
  )
  .reset(getSubscriptions.doneData)

// pending у эффекта один на все карточки, поэтому храним id сохраняемого продукта
export const $savingId = createStore<number | null>(null)
  .on(saveProduct, (_, { id }) => id)
  .reset(updateSubscriptions.done, updateSubscriptions.fail)

sample({
  clock: emailsTabMounted,
  fn: (clientId) => ({ url: `/client/${clientId}/subscriptions` }),
  target: getSubscriptions,
})

sample({
  clock: saveProduct,
  fn: ({ id, body }) => ({ url: `/client/subscriptions/${id}`, body }),
  target: updateSubscriptions,
})

// источник правды — бэк: после успешного PUT перезапрашиваем список
sample({
  clock: updateSubscriptions.done,
  source: $clientId,
  filter: (clientId): clientId is string => Boolean(clientId),
  fn: (clientId) => ({ url: `/client/${clientId}/subscriptions` }),
  target: getSubscriptions,
})

updateSubscriptions.done.watch(() => {
  message.success('Subscriptions saved')
})

updateSubscriptions.failData.watch((failData) => {
  message.error(
    failData.body.message || 'Couldn’t save subscriptions. Try again.',
  )
})
